import { Component } from '@angular/core';
import {
  DialogRef,
  DialogService,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { SupportService } from '../../../services/support.service';

@Component({ standalone: false, 
  selector: 'talk-to-cyborg-dialog',
  templateUrl: './talk-to-cyborg-dialog.component.html',
  styleUrls: ['./talk-to-cyborg-dialog.component.scss'],
})
export class TalkToCyborgDialogComponent {
  public submitted: boolean = false;
  public error: string;
  public isSmallScreen: boolean = false;

  constructor(
    public dialogRef: DialogRef,
    public dialog: DialogService,
    public supportService: SupportService,
  ) {}

  public talkToCyborg(): void {
    this.dialogRef.close(true);
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
